export default __webpack_public_path__ + "static/media/a020-cs-2.f96f3370.svg";